var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.layout,
    { tag: "component" },
    [
      _c("router-view"),
      _vm._v(" "),
      !_vm.storageCache
        ? _c(
            "div",
            { staticClass: "app-hidden" },
            [
              _vm._v("\n\t\t" + _vm._s(/* prefetch icons */) + "\n\t\t"),
              _vm._l(_vm.iconsToPrefetch, function(icon) {
                return _c("v-icon", {
                  key: "icon-prefetch-" + icon,
                  attrs: { name: icon, prefetch: true }
                })
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-modal", {
        staticClass: "open-account__modal",
        attrs: { slug: _vm.slug }
      }),
      _vm._v(" "),
      _vm.showPreloader ? _c("v-preloader") : _vm._e(),
      _vm._v(" "),
      _c("v-anal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }